var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconPersonChalkboardDuotoneSolid(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 46,
    viewBox: "0 0 57 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "person-chalkboard-duotone-solid (3) 1",
    clipPath: "url(#clip0_175_4060)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.30029 25.8125C3.30029 26.7705 3.78154 27.7021 4.65654 28.2295C5.97779 29.0293 7.70154 28.5986 8.49779 27.2715L11.0003 23.0791V42.6875C11.0003 44.2432 12.2515 45.5 13.8003 45.5C15.349 45.5 16.6003 44.2432 16.6003 42.6875V31.4375H18.0003V42.6875C18.0003 44.2432 19.2515 45.5 20.8003 45.5C22.349 45.5 23.6003 44.2432 23.6003 42.6875V17.375H28.5003H34.1003H35.5003C37.049 17.375 38.3003 16.1182 38.3003 14.5625C38.3003 13.0068 37.049 11.75 35.5003 11.75H34.1003H28.5003H21.7715H16.0053C13.0565 11.75 10.3265 13.3057 8.80404 15.8457L3.70279 24.3711C3.43154 24.8193 3.30029 25.3203 3.30029 25.8125ZM13.1003 4.71875C13.1003 5.83763 13.5428 6.91069 14.3304 7.70186C15.1181 8.49303 16.1864 8.9375 17.3003 8.9375C18.4142 8.9375 19.4825 8.49303 20.2701 7.70186C21.0578 6.91069 21.5003 5.83763 21.5003 4.71875C21.5003 3.59987 21.0578 2.52681 20.2701 1.73564C19.4825 0.944474 18.4142 0.5 17.3003 0.5C16.1864 0.5 15.1181 0.944474 14.3304 1.73564C13.5428 2.52681 13.1003 3.59987 13.1003 4.71875Z",
    fill: "url(#paint0_linear_175_4060)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M34.1 11.75V6.125H50.9V23H34.1V17.375H28.5V24.4062C28.5 26.7354 30.3813 28.625 32.7 28.625H52.3C54.6187 28.625 56.5 26.7354 56.5 24.4062V4.71875C56.5 2.38965 54.6187 0.5 52.3 0.5H32.7C30.3813 0.5 28.5 2.38965 28.5 4.71875V11.75H34.1Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_175_4060",
    x1: 3.58814,
    y1: 45.5,
    x2: 47.8285,
    y2: 31.4844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#47E4A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4CCEDD"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_175_4060"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 45,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPersonChalkboardDuotoneSolid);
export default __webpack_public_path__ + "static/media/icon-person-chalkboard-duotone-solid.764474e515333f818f87ce584787a005.svg";
export { ForwardRef as ReactComponent };